<template>
  <h1>canvas教程</h1>
  <canvas id="canvas" width="500" height="500"></canvas>
  <button @click="skipTo">跳转</button>
</template>
<script setup>
import { onMounted, nextTick } from "vue";
import router from "../../../router";

onMounted(() => {
  nextTick(() => {
    // 绘制canvas
    draw();
  });
});

const draw = () => {
  var c = document.getElementById("canvas");
  var ctx = c.getContext("2d");

  // 创建渐变
  var radgrad4 = ctx.createRadialGradient(0, 150, 50, 0, 140, 90);
  radgrad4.addColorStop(0, "#F4F201");
  radgrad4.addColorStop(0.8, "#E4C700");
  radgrad4.addColorStop(1, "rgba(228,199,0,0)");

  // 画图形
  ctx.fillStyle = radgrad4;
  ctx.fillRect(0, 0, 150, 150);
};
</script>
<style scoped></style>
